import trace from '../data/structures-trace.json';
import type { Ride } from './ride';

export const STRUCTURES_TRACE: Ride = { ...trace, source: 'synthetic' };

/** Julian requested this particular authored public path; all other generated paths remain rejected. */
export function isCuratedStructuresPath(input: Partial<Ride>): boolean {
  return input.source === 'synthetic' && input.id === STRUCTURES_TRACE.id
    && JSON.stringify(input.points) === JSON.stringify(STRUCTURES_TRACE.points);
}
